<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.name" placeholder="Search" @change="filterZones"></el-input>
        </el-form-item>
        <el-form-item label="Show Panel Serial Numbers">
          <el-checkbox v-model="columns.panelSerial"></el-checkbox>
        </el-form-item>
        <el-form-item label="Show Billing Due Date">
          <el-checkbox v-model="columns.billingDueDate"></el-checkbox>
        </el-form-item>
        <el-form-item align="right">
          <el-button type="info" size="medium" @click="addZoneClick()">+ Add Zone</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="zones" highlight-current-row v-loading="listLoading" style="width: 100%">
      <el-table-column prop="name" label="Zone Name" width="300" sortable></el-table-column>
      <el-table-column prop="gsd_id" label="Zone ID" sortable width="150"></el-table-column>
      <el-table-column prop="boro_name" label="Boro" sortable width="150"></el-table-column>
      <el-table-column v-if="columns.panelSerial" prop="id" label="Panel Serial" width="350"></el-table-column>
      <el-table-column v-if="columns.billingDueDate" label="Next Billing" width="350">
        <template scope="scope">
          <div v-if="scope.row.billingDue"><el-tag type="danger">{{ scope.row.nextBillingAt }}</el-tag></div>
          <div v-else><el-tag type="success">{{ scope.row.nextBillingAt }}</el-tag></div>
        </template>
      </el-table-column>

      <el-table-column align="right">
        <template scope="scope">
          <div style="display: inline-block">
            <el-button type="info" size="small" @click="zoneActivate(scope.$index, scope.row)">Activate</el-button>
            <el-button type="info" size="small" @click="zoneEditClick(scope.$index, scope.row)">Edit</el-button>
            <!--<el-button type="danger" size="small" @click="zoneDeleteClick(scope.$index, scope.row)">Delete</el-button>-->
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="total"
        style="float: right"></el-pagination>
    </el-col>
    <!--Zone management -->
    <el-dialog :title="zoneDialog.title" :visible.sync="zoneDialog.visible">
      <el-form :model="zoneDialog.form" v-loading="zoneDialog.loading" @submit.native.prevent>
        <el-form-item label="Zone Name">
          <el-input v-model="zoneDialog.form.name" type="text"></el-input>
        </el-form-item>
        <el-form-item label="Zone ID">
          <el-input v-model="zoneDialog.form.zoneID" type="text"></el-input>
        </el-form-item>
        <el-form-item label="Boro">
          <el-select v-model="zoneDialog.form.boro" placeholder="Select">
            <el-option v-for="item in boro_options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Next Billing">
          <el-date-picker v-model="zoneDialog.form.nextBillingAt" type="date" placeholder="Pick a date" />
        </el-form-item>
        <el-form-item label="Panel ID" v-if="zoneDialog.showPanelID">
          <el-input v-model="zoneDialog.form.deviceID" type="text"></el-input>
        </el-form-item>
        <el-form-item style="margin-top: 10px">
          <el-button type="primary" style="margin-top: 10px" @click="zoneDialogClick()">Save</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </section>
</template>

<script>
import Axios from "axios"
import UserService from "@/api/user.service"
import dateFormat from "dateformat"


export default {
  data() {
    return {
      columns: {
        panelSerial: false,
        billingDueDate: true
      },
      boro_options: [
        {
          value: 1,
          label: "Manhattan"
        },
        {
          value: 2,
          label: "Queens"
        }
      ],
      filters: {
        name: ""
      },
      zones: [],
      allZones: [],
      users: [],
      total: 0,
      page: 1,
      listLoading: false,
      user: this.$session.get("User"),
      zoneDialog: {
        title: "",
        visible: false,
        loading: false,
        showPanelID: false,
        form: {
          name: "",
          deviceID: "",
          zoneID: "",
          boro: "",
          nextBillingAt: ""
        }
      }
    }
  },
  methods: {
    // isDate(date) {
    // return (new Date(date) !== "Invalid Date") && !isNaN(new Date(date));
    // },
    sortBillingMethod(a, b) {
      console.log(a)
      return a - b
    },
    zoneEditClick(index, row) {
      this.zoneDialog.title = "Edit Zone"
      this.zoneDialog.form.name = row.name
      this.zoneDialog.form.deviceID = row.id
      this.zoneDialog.form.zoneID = row.gsd_id
      this.zoneDialog.form.boro = row.boro_id
      this.zoneDialog.form.nextBillingAt = row.nextBillingAt
      this.zoneDialog.visible = true
      this.zoneDialog.showPanelID = false
    },
    zoneDeleteClick(index, row) {
      this.$confirm("This will permanently delete the Zone. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning"
      })
        .then(() => {
          Axios.all([UserService.deleteZone(row.id)]).then(
            Axios.spread((deleteZoneResponse) => {
              if (deleteZoneResponse.data.result == "success") {
                this.getZones()
                this.$message({
                  type: "success",
                  message: "Delete completed"
                })
              } else {
                this.$message({
                  type: "warning",
                  message: "Error Deleting Zone"
                })
              }
            })
          )
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled"
          })
        })
    },
    handleCurrentChange() { },
    zoneDialogClick() {
      if (this.zoneDialog.title == "Add Zone") {
        this.addZone()
      } else {
        this.editZone()
      }
    },
    editZone() {
      if (!this.zoneDialog.form.nextBillingAt) {
        const h = this.$createElement
        this.$notify({
          title: "Update Zone",
          message: "Error Billing At cannot be empty",
          type: "error"
        })
        return
      }
      // if(!isDate(this.zoneDialog.form.nextBillingAt))
      // {
      //      const h = this.$createElement
      //       this.$notify({
      //         title: "Update Zone",
      //         message: "Error Billing - Date is not valid",
      //         type: "error"
      //       })
      //       return
      // }
      this.zoneDialog.loading = true
      const dateOfNextBilling = new Date(this.zoneDialog.form.nextBillingAt.toLocaleDateString('en-CA') + 'T00:00:00.000Z')
      Axios.all([UserService.updateZone(this.zoneDialog.form.deviceID, this.zoneDialog.form.name, this.zoneDialog.form.zoneID, this.zoneDialog.form.boro, dateOfNextBilling)]).then(
        Axios.spread((zoneUpdateResponse) => {
          this.zoneDialog.loading = false
          this.zoneDialog.visible = false
          if (zoneUpdateResponse.data.result == "success") {
            const h = this.$createElement
            this.$notify({
              title: "Update Zone",
              message: "Sucess",
              type: "info"
            })
            this.getZones()
          } else {
            console.log(zoneUpdateResponse)
            const h = this.$createElement
            this.$notify({
              title: "Update Zone",
              message: "Error while updating Zone",
              type: "error"
            })
          }
        })
      )
    },
    addZone() {
      if (!this.zoneDialog.form.nextBillingAt) {
        const h = this.$createElement
        this.$notify({
          title: "Update Zone",
          message: "Error Billing At cannot be empty",
          type: "error"
        })
        return
      }
      this.zoneDialog.loading = true
      const dateOfNextBilling = new Date(this.zoneDialog.form.nextBillingAt.toLocaleDateString('en-CA') + 'T00:00:00.000Z')
      Axios.all([UserService.addZone(this.zoneDialog.form.deviceID, this.zoneDialog.form.name, this.zoneDialog.form.zoneID, this.zoneDialog.form.boro, dateOfNextBilling)]).then(
        Axios.spread((zoneAddResponse) => {
          this.zoneDialog.loading = false
          this.zoneDialog.visible = false
          if (zoneAddResponse.data.result == "success") {
            const h = this.$createElement
            this.$notify({
              title: "Add Zone",
              message: "Zone Added",
              type: "info"
            })
            this.getZones()
          } else {
            const h = this.$createElement
            this.$notify({
              title: "Add Zone",
              message: "Error while adding zone",
              type: "error"
            })
          }
        })
      )
    },
    addZoneClick() {
      this.zoneDialog.title = "Add Zone"
      this.zoneDialog.visible = true
      this.zoneDialog.form.name = ""
      this.zoneDialog.form.deviceID = ""
      this.zoneDialog.form.zoneID = ""
      this.zoneDialog.form.boro = 1
      this.zoneDialog.showPanelID = true
    },
    filterZones() {
      if (this.filters.name.length > 0) {
        this.zones = this.allZones.filter((zone) => zone.name.toLowerCase().includes(this.filters.name.toLowerCase()))
      } else {
        this.zones = this.allZones
      }
    },
    getZones() {
      this.listLoading = true
      Axios.all([UserService.getZones(this.user.email)]).then(
        Axios.spread((zonesResponse) => {
          this.listLoading = false
          this.allZones = zonesResponse.data
          for (var zone of this.allZones) {
            zone.billingDue = false;
            zone.nextBillingAt = ""

            if (zone.next_billing_at) {
              console.log(zone.billing_due)
              zone.nextBillingAt = dateFormat(zone.next_billing_at, "yyyy-mm-dd")
              zone.billingDue = zone.billing_due == 1
            }
          }
          console.log(this.allZones)
          //this.zones = zonesResponse.data
          this.filterZones()
        })
      )
      Axios.all([UserService.getBoros()]).then(
        Axios.spread((getBorosResponse) => {
          this.boro_options = getBorosResponse.data
        })
      )
    },
    zoneActivate(index, row) {
      console.log(this.user)
      UserService.switchZone(row.id, this.user.email).then((response) => {
        UserService.getUser(this.user.email).then((response) => {
          if (response.data.error == null) {
            this.$session.set("User", response.data)
            this.$root.$emit("zoneChanged", row.id)
            this.$router.push("/Dashboard")
            console.log(row.id)
          }
        })
      })
    }
  },
  mounted() {
    this.getZones()
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// Zones.vue?c293a9e4